import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRouter } from './App';
import './style.css';
import { store } from './store/store';
import { Provider } from 'react-redux';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

const root = ReactDOM.createRoot(rootElement);
root.render(
    <Provider store={store}>
        <React.StrictMode>
            <AppRouter />
        </React.StrictMode>
    </Provider>,
);
